import { Component, OnInit, Output, EventEmitter, OnDestroy, Input, Inject } from '@angular/core';
import { RequestedHistoryDetails, RequestedHistoryDetailsRequest } from '../../history';
import { TranslateService } from '@ngx-translate/core';
import { HistoryService } from '../../history.service';
import { INITIAL_OPTIONS } from '@ngrx/store-devtools/src/config';
import { DocumentStatusMap } from '../../signing-history/signing-history.component';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from '@env/environment';
import { SigningService } from '@app/certificates/signing/signing.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { InfoService } from '@app/core/info/info.service';

@Component({
  selector: 'cloud-requested-history-details',
  templateUrl: './requested-history-details.component.html',
  styleUrls: ['./requested-history-details.component.scss']
})
export class RequestedHistoryDetailsComponent implements OnInit, OnDestroy {

  @Output() close: EventEmitter<any> = new EventEmitter();

  wait = true;
  requestedDetails: RequestedHistoryDetails[];
  displayOptions: RequestedHistoryDetailsRequest;
  requestedId: number;
  readonly dateFormat = environment.dateFormat;
  readonly timeFormat = environment.timeFormat;
  unsubscribe$: Subject<void> = new Subject<void>();
  signedfileName: any;

  constructor(
    private translateService: TranslateService,
    private historyService: HistoryService,
    private signingService: SigningService,
    public info: InfoService,
    @Inject(MAT_DIALOG_DATA) data: number
  ) {
        this.requestedId = data;
    }

  ngOnInit() {
    this.initDisplayOptions();
    this.loadRequestedHistoryDetails();
    this.wait = false;
  }

  initDisplayOptions() {
    this.displayOptions = {};
    this.displayOptions.requestedId = this.requestedId;
  }

  loadRequestedHistoryDetails() {
      this.historyService.getRequestsHistoryDetails(this.displayOptions).subscribe(res => {
      if (res.data) {
        this.setRequestedHistoryDetails(res.data.content);
      }
    });
  }

  setRequestedHistoryDetails(requestedHistoryDetails: RequestedHistoryDetails[]) {
    if (requestedHistoryDetails) {
      this.requestedDetails = requestedHistoryDetails.map(a => Object.assign({
        firstName: a.firstName,
        lastName: a.lastName,
        status: a.status,
        statusIcon: DocumentStatusMap.get(a.status),
        signDate: a.signDate,
        dnCn: a.dnCn,
        fileId: a.fileId,
        deadLineTs: a.deadLineTs
      }));
    }
  }

  hasFileForDownload(item: RequestedHistoryDetails) {
    const hasFile = item.fileId != '-1';
    return hasFile;
  }

  isIE() {
    const match = navigator.userAgent.search(/(?:Edge|MSIE|Trident\/.*; rv:)/);
    let isIE = false;
    if (match !== -1) {
      isIE = true;
    }
    return isIE;
  }

  onDownloadFile(item: RequestedHistoryDetails) {
    this.signingService.getRequestedFile(item.fileId)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (result) => {
          if (result.status !== 200) {
            this.info.error(result.message);
          } else {
            this.signedfileName = result.headers.get('Content-Disposition');
            let fileName = this.signedfileName.substring(this.signedfileName.indexOf('=') + 2, (this.signedfileName.length - 1));
            if (this.isIE()) {
              fileName = decodeURIComponent(fileName);
              const nav = (window.navigator as any) 
              if(nav.msSaveOrOpenBlob){
                nav.msSaveOrOpenBlob(result.body, fileName);
              }
            } else {
              const url = window.URL.createObjectURL(result.body);
              const link = document.createElement('a');
              link.href = url;
              link.download = decodeURI(fileName);
              document.body.appendChild(link);
              link.click();
            }
          }
        }
      );
  }

  displayUserName(item: RequestedHistoryDetails) {
    if (item.firstName && item.lastName) {
      return this.translateService.currentLang === 'bg' ? item.firstName.bg + ' ' + item.lastName.bg :
        item.firstName.en + ' ' + item.lastName.en;
    }
    return item.dnCn;
  }

  ngOnDestroy() {
  }

  closeDialog() {
    this.close.emit(null);
  }
}
